import styled, { css } from 'styled-components'

import { Pill as PillV2 } from '@baseV2'
import { Spacings, Text } from '@styles'

const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	padding: ${Spacings.SPACING_5B};
	background: ${({ theme }) => theme.colors.surface.card};
	border: 1px solid ${({ theme }) => theme.colors.border.default};
	border-radius: ${({ theme }) => theme.radius.lg};
	transition: border-color 0.15s ease-in-out;

	${({ hoverable = true, theme }) =>
		hoverable &&
		css`
			cursor: pointer;
			&:hover {
				border-color: ${theme.colors.brand.primary};
			}
		`}

	${({ selected, theme }) =>
		selected &&
		css`
			border-color: ${theme.colors.brand.primary};
		`}
`

const AddressId = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.colors.text.secondary};
`

const AddressText = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
	font-size: ${Text.MEDIUM};
	color: ${({ theme }) => theme.colors.text.primary};
	line-height: 1.45;

	p {
		margin: 0;
	}
`

const GSTAddressCardV2 = ({ gst, address, selected = false, hoverable = true }) => {
	return (
		<CardWrapper selected={selected} hoverable={hoverable}>
			<PillV2 color='info' variant='subtle' round>
				GST Number : {gst ?? '--'}
			</PillV2>
			{address && (
				<>
					<AddressId>{`Address Id : ${address?.address_id ?? 'N/A'}`}</AddressId>
					<AddressText>
						{address?.complete_address && <p>{address.complete_address}</p>}
						<p>
							{address?.city}, {address?.state} - {address?.pincode}
						</p>
					</AddressText>
				</>
			)}
		</CardWrapper>
	)
}

export default GSTAddressCardV2
